/*
 * Lib Module Datepicker
 */

Lib.Datepicker = (function() {

    let self = {};

    // Set moment locale
    moment.locale('nl');

    // LibDocReady
    $(Lib).on('document.ready', function() {

        // Translate to dutch and make the russian fallback also dutch
        $.fn.datepicker.language['ru'] = $.fn.datepicker.language['nl'] = {
            days: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
            daysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            daysMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
            monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
            today: 'Vandaag',
            clear: 'Legen',
            dateFormat: 'dd-mm-yyyy',
            timeFormat: 'hh:ii',
            firstDay: 0
        };
        // Bind the datepickers
        self.initializeDatepickers($('input[data-datepicker-options]'));
    });

    /**
     * Initialize
     * @param datepickers
     */
    self.initializeDatepickers = function(datepickers) {
        // If datepickers found
        if (datepickers.length) {

            // Loop through each datepicker
            datepickers.each(function() {

                // Scope letiable
                let datepickerInput = $(this);

                // Find the alt field
                let altField = $('#' + datepickerInput.attr('id').replace('Picker', ''));

                // Get the options
                let datepickerOptions = datepickerInput.data('datepicker-options');

                // Get some options with defaults if not provided
                let acceptedFormats = Lib.Hash.get(datepickerOptions, 'acceptedFormats', ['DD-MM-YYYY', 'D-M-YYYY', 'DD MMMM YYYY']);
                let postFormat = Lib.Hash.get(datepickerOptions, 'postFormat', 'yyyy-mm-dd');
                let displayFormat = Lib.Hash.get(datepickerOptions, 'displayDateFormat', 'dd-mm-yyyy');
                let displayTimeFormat = Lib.Hash.get(datepickerOptions, 'displayTimeFormat', false);

                // If we want a mindate
                if ('minDate' in datepickerOptions && typeof datepickerOptions.minDate !== 'object') {
                    datepickerOptions.minDate = new Date(datepickerOptions.minDate);
                }

                // If we want a maxdate
                if ('maxDate' in datepickerOptions && typeof datepickerOptions.maxDate !== 'object') {
                    datepickerOptions.maxDate = new Date(datepickerOptions.maxDate);
                }

                // Now extend the options with the data attribute options
                let options = $.extend({
                    language: 'nl',
                    timepicker: false,
                    altFieldDateFormat: postFormat,
                    toggleSelected: false,
                    keyboardNav: false,
                    todayButton: new Date(),
                    dateFormat: displayFormat,
                    position: 'right center',
                    clearButton: false,
                    minutesStep: 5,
                    firstDay: 1,
                    timeFormat: displayTimeFormat
                }, datepickerOptions);

                // Set the altField
                options.altField = altField;

                // Bind the onHide
                options.onHide = function(calendarInstance, end) {
                    if (end === false) {

                        //
                        let testFormats = [].concat(acceptedFormats);
                        $.each(acceptedFormats, function(i, format) {
                            testFormats.push(format.replace('YYYY', 'YY'));
                        });

                        // Set visible value in calendar on show
                        self.setCalendarValue(datepickerInput, _.union(testFormats, acceptedFormats));

                        // On hide, set the position back to default
                        calendarInstance.update('position', 'right center');
                    } else {
                        if (typeof datepickerInput.data('autosubmit') !== 'undefined' && datepickerInput.data('allowautosubmit') === true) {
                            datepickerInput.closest('form').submit();
                        }
                    }

                };

                // Bind the onShow
                options.onShow = function(calendarInstance, end) {
                    if (end === false) {

                        // Set visible value in calendar on show
                        self.setCalendarValue(datepickerInput, acceptedFormats);

                        //
                        // Loop through all positions and see if the datepicker fits
                        //
                        let positions = (datepickerOptions.onlyTimepicker) ? ['right top', 'bottom center'] : ['right center', 'right bottom', 'right top', 'bottom center'];
                        $.each(positions, function(i, pos) {
                            calendarInstance.update('position', pos);
                            let fits = Lib.Element.fitsInViewport(calendarInstance.$datepicker[0]);
                            if (fits.all) {
                                // Done
                                return false;
                            }
                        });
                    }
                };

                options.onSelect = function() {
                    if (datepickerInput.data('cal-no-change') !== true) {
                        datepickerInput.trigger('change');
                        if (options.timepicker === false) {
                            datepickerInput.data('datepicker').hide();
                        }
                    }
                };

                try {

                    // Launch the datepicker
                    let dp = datepickerInput.datepicker(options).data('datepicker');

                    // Remove readonly from the datepicker
                    datepickerInput.prop('readonly', 0);

                    if (datepickerInput.is(':focus')) {
                        dp.show();
                    }

                    if (typeof datepickerInput.data('autosubmit') !== 'undefined') {
                        datepickerInput.on('change', function() {
                            $(this).data('allowautosubmit', true);
                        });
                    }

                    datepickerInput.on('datepicker:update', function() {
                        self.setCalendarValue(datepickerInput, acceptedFormats);
                    });

                    Mousetrap(datepickerInput.get(0)).bind('enter', function() {
                        self.setCalendarValue(datepickerInput, acceptedFormats);
                    });

                } catch (error) {

                }

            });

        }
    };

    /**
     * Function to set the visible date in the datepicker, based on user input
     * @param datepickerInput
     * @param format
     */
    self.setCalendarValue = function(datepickerInput, format) {
        let currentMoment = moment(datepickerInput.val(), format, true);
        if (currentMoment.isValid()) {
            let currentDate = currentMoment.toDate();
            datepickerInput.data('datepicker').date = currentDate;
            datepickerInput.data('cal-no-change', true);
            datepickerInput.data('datepicker').selectDate(currentDate);
            datepickerInput.data('cal-no-change', false);
            datepickerInput.closest('form').trigger('change');
        } else {
            if (datepickerInput.val() !== '') {
                datepickerInput.data('datepicker').$altField.val('invalid');
            }
        }
    };

    return self;

})();
